export const PD_DEFAULT_GRAPH: any = {
  "name": '',
  "x_axis_configuration": {
    "ticks": "datetime"
  },
  "y_axis_configuration": {
    "left_1": {
      "data": []
    },
    "left_2": {
      "data": []
    },
    "right_1": {
      "data": []
    }
  }
};
